import React from 'react';
import { motion } from 'framer-motion';
import { SocialLink } from '../types';

const Footer: React.FC = () => {
  const socialLinks: SocialLink[] = [
    {id: '1', name: 'Email', url: 'mailto:hodlwarden@gmail.com', icon: 'fas fa-envelope'},
    { id: '2', name: 'GitHub', url: 'https://github.com/hodlwarden', icon: 'fab fa-github' },
    // { id: '2', name: 'LinkedIn', url: 'https://linkedin.com/in/hodlwarden', icon: 'fab fa-linkedin' },
    { id: '3', name: 'Twitter', url: 'https://twitter.com/hodlwarden', icon: 'fab fa-twitter' },
    { id: '4', name: 'Discord', url: 'https://discord.gg/hodlwarden', icon: 'fab fa-discord' }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: "easeOut"
      }
    }
  };

  return (
    <footer className="footer">
      <div className="container">
        <motion.div
          className="footer-content"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <motion.div className="footer-text" variants={itemVariants}>
            <p>&copy; 2024 HODL Portfolio. Building the decentralized future.</p>
          </motion.div>

          <motion.div className="footer-social" variants={containerVariants}>
            {socialLinks.map((link) => (
              <motion.a
                key={link.id}
                href={link.url}
                className="social-link"
                variants={itemVariants}
                whileHover={{ 
                  scale: 1.1,
                  backgroundColor: '#00d4ff',
                  boxShadow: '0 5px 15px rgba(0, 212, 255, 0.4)'
                }}
                whileTap={{ scale: 0.95 }}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={link.name}
              >
                <i className={link.icon} style={{
                  fontSize: '1.2rem',
                  transition: 'all 0.3s ease',
                  filter: 'drop-shadow(0 0 6px rgba(0, 212, 255, 0.2))'
                }}></i>
              </motion.a>
            ))}
          </motion.div>
        </motion.div>

        <motion.div
          className="footer-bottom"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.5 }}
        >
          <motion.p
            style={{ 
              textAlign: 'center', 
              color: '#aaaaaa', 
              fontSize: '0.9rem',
              marginTop: '1rem'
            }}
            animate={{
              opacity: [0.5, 1, 0.5]
            }}
            transition={{
              duration: 3,
              repeat: Infinity,
              ease: "easeInOut"
            }}
          >
            🚀 Powered by React, TypeScript & Blockchain Technology
          </motion.p>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;

